import React from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { useRefreshPermissionActions } from 'common/core/hooks/useRefreshPermissionActions'
import { refreshPermissionsActions } from 'common/core/reducers/refreshPermissions'

export const HelpRefreshPermissionButton = ({ onClick }: { onClick: () => void }) => {
  const availableActions = useRefreshPermissionActions('manual')

  const isNeedToShowButton = availableActions.length > 0
  const isOnlyOneAvailable = availableActions.length === 1

  const dispatch = useAppDispatch()

  const handleRefreshPermissionsClick = () => {
    if (isOnlyOneAvailable) {
      const { href } = availableActions[0]

      window.open(href, '_self')
    } else {
      dispatch(refreshPermissionsActions.open())
    }

    onClick()
  }

  if (!isNeedToShowButton) {
    return null
  }

  return (
    <div className="text-center p-x-sm p-y-sm b-y">
      <div className="m-b-xs text-body-sm text-secondary">
        {l.translate('Facing issues with Automations?')}
      </div>
      <BtnV2
        variant="default"
        className="section-btn"
        onClick={handleRefreshPermissionsClick}
        fullWidth
      >
        {l.translate('Refresh Permissions')}
      </BtnV2>
    </div>
  )
}
